export const PlanReviewFileFragment = gql`
  fragment PlanReviewFileFragment on File {
    ...FileFragment
    initialPlansSetVersionNumber
    pageProcessingFinishedAt
    pages {
      ...PlanReviewFilePageFragment
    }
  }
  fragment PlanReviewFilePageFragment on FilePage {
    isModifiedOnRecordPlansSet(currentRecordPlansSetId: $recordPlansSetId)
    ...FilePageFragment
  }
`
export const PlanReviewFieldGroupFragment = gql`
  fragment PlanReviewFieldGroupFragment on FieldGroup {
    id
    fields {
      ...PlanReviewFieldFragment
    }
  }
  fragment PlanReviewFieldFragment on Field {
    id
    label
    file {
      ...PlanReviewFileFragment
    }
    files {
      ...PlanReviewFileFragment
    }
  }
`
